export default {
  computed: {
    keymap() {
      return {
        'ctrl+shift+q': this.toggleHacks
      };
    },
    hack() {
      return this.$store.state.hack;
    }
  },
  methods: {
    toggleHacks() {
      this.$store.dispatch('toggleHacks');
    }
  }
}
